import React from 'react'
import PropTypes from 'prop-types'
import { default as dayjs } from 'dayjs'

import { useGetMutateCall } from '../../lib/api/get'
import { useCreateCall } from '../../lib/api/create'
import { useUpdateCall } from '../../lib/api/update'

export const MarksEntry = ({ isLocalEnvironment, routeData }) => {
  const [selectAcademicYear, setSelectAcademicYear] = React.useState(null)
  const [selClassSectionId, setSelClassSectionId] = React.useState(null)
  const [classSectionSyllabusClassCombinationsData, setClassSectionSyllabusClassCombinationsData] =
    React.useState(null)
  const [syllabusCombinationSubjectExamsData, setSyllabusCombinationSubjectExamsData] =
    React.useState(null)
  const [examScheduleData, setExamScheduleData] = React.useState(null)
  const [selSubjectId, setSelSubjectId] = React.useState(null)
  const [selectedFilters, setSelectedFilters] = React.useState({
    classSectionId: '',
    syllabusCombinationSubjectId: '',
    examId: '',
    examDate: '',
  })

  const [classSectionMarksData, setClassSectionMarksData] = React.useState({
    data: { formData: [] },
  })
  const deps = JSON.parse(sessionStorage.getItem('auth')).state.dependeciesFormAPIS || null
  const getCallMutation = useGetMutateCall()
  const createCallMutation = useCreateCall()
  const updateCallMutation = useUpdateCall()

  const onSelectClassSection = async (value) => {
    setSelClassSectionId(JSON.parse(value).classSectionId)
    selectedFilters['classSectionId'] = JSON.parse(value).classSectionId
    setSelectedFilters(selectedFilters)
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'syllabusCombinationSubject',
        params: '&syllabusCombinationId=' + JSON.parse(value).syllabusCombinationId,
        doPolling: false,
        isDynamic: true,
      })
      .then((resp) => {
        setClassSectionSyllabusClassCombinationsData(resp)
      })
  }
  const onSelectClassSectionSubject = async (value) => {
    selectedFilters['syllabusCombinationSubjectId'] = value
    setSelectedFilters(selectedFilters)
    const subData = classSectionSyllabusClassCombinationsData.formData.filter(
      (f) => f.syllabusCombinationSubjectId === value,
    )
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'syllabusCombinationSubjectExam',
        params: '&syllabusCombinationSubjectId=' + value,
        doPolling: false,
        isDynamic: true,
      })
      .then((resp) => {
        setSyllabusCombinationSubjectExamsData(resp)
      })
    setSelSubjectId(subData)
  }
  const onSelectClassSectionSubjectExam = async (value) => {
    selectedFilters['examId'] = JSON.parse(value).examId
    selectedFilters['subjectExamId'] = JSON.parse(value).subjectExamId
    setSelectedFilters(selectedFilters)
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'syllabusCombinationSubjectExamSchedule',
        params:
          '&syllabusCombinationSubjecExamId=' +
          JSON.parse(value).subjectExamId +
          '&academicYearId=' +
          selectAcademicYear +
          '&classSectionId=' +
          selClassSectionId,
        doPolling: false,
        isDynamic: true,
      })
      .then((resp) => {
        setExamScheduleData(resp)
      })
  }
  const onSelectClassSectionSubjectExamSchedule = async (value) => {
    selectedFilters['examDate'] = JSON.parse(JSON.parse(value)).date
    selectedFilters['examScheduleId'] = JSON.parse(JSON.parse(value)).id
    setSelectedFilters(selectedFilters)
    let emData
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'applicationAYClassSectionsSubjectExamMark',
        params:
          '&classSectionId=' +
          selClassSectionId +
          '&syllabusCombinationSubjectId=' +
          selectedFilters.syllabusCombinationSubjectId +
          '&examId=' +
          selectedFilters.examId +
          '&syllabusCombinationSubjectExamScheduleId=' +
          JSON.parse(JSON.parse(value)).id,
        doPolling: false,
        isDynamic: true,
      })
      .then((resp) => {
        emData = { data: resp }
      })
    await getCallMutation
      .mutateAsync({
        apiURL: isLocalEnvironment + '/getData',
        apiEndpoint: 'applicationAYClassSections',
        params:
          '&classSectionId=' +
          selectedFilters.classSectionId +
          '&academicYearId=' +
          selectAcademicYear,
      })
      .then((resp) => {
        processData({ data: resp }, emData)
      })
  }

  const processData = (data, emData) => {
    const cmData = []
    data.data.formData.map((d) => {
      //const dData = { ...d };
      emData.data.formData.map((m) => {
        if (d.applicationAYClassSectionId === m.applicationAYClassSectionId) {
          d['marks'] = m.marks
          d['grade'] = m.grade
          d['notes'] = m.notes
          d['applicationAYClassSectionsSubjectExamMarksId'] =
            m.applicationAYClassSectionsSubjectExamMarksId
        }
      })
      cmData.push(d)
    })

    setClassSectionMarksData({ data: { formData: cmData } })
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    const data = new FormData(e.target)
    //const examSchedule = JSON.parse(JSON.parse(examDate))
    //const formData={...createData,marks:data.get('marks'),grade:data.get("grade"),notes:data.get("notes")}
    const formsData = {
      applicationAYClassSectionId: data.get('applicationAYClassSectionId'),
      classSectionId: selectedFilters.classSectionId,
      syllabusCombinationId: selSubjectId[0].syllabusCombinationId,
      syllabusCombinationSubjectId: selectedFilters.syllabusCombinationSubjectId,
      subjectId: selSubjectId[0].subjectId,
      syllabusCombinationSubjectExamId: selectedFilters.subjectExamId,
      examId: selectedFilters.examId,
      examDate: selectedFilters.examDate,
      marks: data.get('marks'),
      grade: data.get('grade'),
      notes: data.get('notes'),
      syllabusCombinationSubjectExamScheduleId: selectedFilters.examScheduleId,
    }
    await createCallMutation.mutateAsync({
      url: isLocalEnvironment + '/addData',
      apiEndpoint: 'applicationAYClassSectionsSubjectExamMark',
      data: formsData,
      messageTitle: 'Exam Marks',
      message: 'Marks added successfully1!',
      params: '',
      isMultipart: true,
      isDynamic: true,
    })
  }

  const handleUpdateSubmit = async (e) => {
    e.preventDefault()

    const data = new FormData(e.target)

    //const formData={...createData,marks:data.get('marks'),grade:data.get("grade"),notes:data.get("notes")}
    const formsData = {
      marks: data.get('marks'),
      grade: data.get('grade'),
      notes: data.get('notes'),
    }

    await updateCallMutation.mutateAsync({
      url: isLocalEnvironment + '/updateData',
      apiEndpoint: 'applicationAYClassSectionsSubjectExamMark',
      data: formsData,
      id: data.get('applicationAYClassSectionsSubjectExamMarksId'),
      messageTitle: 'Exam Marks',
      message: 'Marks updated successfully1!',
      params: '',
      isMultipart: true,
      isDynamic: true,
    })
  }
  const isLayoutDark = sessionStorage.getItem('themeLayout')
    ? sessionStorage.getItem('themeLayout')
    : false
  return (
    <React.Fragment key={isLayoutDark}>
      <div className="trtui-row">
        <div className="trtui-col-12">
          <div className="trtui-page-title-box trtui-d-sm-flex trtui-align-items-center trtui-justify-content-between">
            <h4 className="trtui-mb-sm-0">{routeData.pageTitle}</h4>
          </div>
        </div>
      </div>
      <div className="trtui-card-body">
        <div className="trtui-row">
          <div key="academicYear" className="trtui-col-md-2 trtui-has-validation">
            <label>Academic Year</label>
            <select
              className={`trtui-form-control trtui-mb-2`}
              style={{
                paddingRight: 'calc(1.5em + 1rem)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
              }}
              onChange={(e) => setSelectAcademicYear(e.target.value)}
            >
              <option value={''}>Select Academic Year</option>
              {deps.academicYears?.formData?.length > 0 &&
                deps.academicYears?.formData?.map((r, rInd) => (
                  <option key={rInd} value={r.academicYearId}>
                    {r.academicYearName}
                  </option>
                ))}
            </select>
          </div>
          <div key="classSection" className="trtui-col-md-2 trtui-has-validation">
            <label>Class Section</label>
            <select
              className={`trtui-form-control trtui-mb-2`}
              style={{
                paddingRight: 'calc(1.5em + 1rem)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
              }}
              onChange={(e) => onSelectClassSection(e.target.value)}
            >
              <option value={''}>Select Room</option>
              {deps.classSections?.formData?.length > 0 &&
                deps.classSections?.formData?.map((r, rInd) => (
                  <option
                    key={rInd}
                    value={JSON.stringify({
                      syllabusCombinationId: r.syllabusCombinationId,
                      classSectionId: r.classSectionId,
                    })}
                  >
                    {r.classSectionName}
                  </option>
                ))}
            </select>
          </div>
          <div key="syllabusClassCombinations" className="trtui-col-md-2 trtui-has-validation">
            <label>Subject</label>
            <select
              className={`trtui-form-control trtui-mb-2`}
              style={{
                paddingRight: 'calc(1.5em + 1rem)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right calc(0.375em + 0.25rem) center',
                backgroundSize: 'calc(0.75em + 0.5rem) calc(0.75em + 0.5rem)',
              }}
              onChange={(e) => {
                onSelectClassSectionSubject(e.target.value)
              }}
              disabled={
                classSectionSyllabusClassCombinationsData !== null &&
                classSectionSyllabusClassCombinationsData.formData.length > 0
                  ? false
                  : true
              }
            >
              <option>
                {classSectionSyllabusClassCombinationsData !== null &&
                classSectionSyllabusClassCombinationsData.formData.length > 0
                  ? 'Select Subject'
                  : 'Loading...'}
              </option>
              {classSectionSyllabusClassCombinationsData !== null &&
                classSectionSyllabusClassCombinationsData.formData.length > 0 &&
                classSectionSyllabusClassCombinationsData.formData.map((ops, opsInd) => (
                  <option key={opsInd} value={ops.syllabusCombinationSubjectId}>
                    {ops.subjects.subjectName}
                  </option>
                ))}
            </select>
          </div>
          <div key="ClassSectionSubjectExam" className="trtui-col-md-3 trtui-has-validation">
            <label>Exam</label>
            <select
              className="trtui-form-control"
              onChange={(e) => {
                onSelectClassSectionSubjectExam(e.target.value)
              }}
              disabled={
                syllabusCombinationSubjectExamsData !== null &&
                syllabusCombinationSubjectExamsData.formData.length > 0
                  ? false
                  : true
              }
            >
              <option>
                {syllabusCombinationSubjectExamsData !== null &&
                syllabusCombinationSubjectExamsData.formData.length > 0
                  ? 'Select Exam'
                  : 'Loading...'}
              </option>
              {syllabusCombinationSubjectExamsData !== null &&
                syllabusCombinationSubjectExamsData.formData.length > 0 &&
                syllabusCombinationSubjectExamsData.formData
                  .sort((a, b) => a.examName - b.examName)
                  .map((ops, opsInd) => (
                    <option
                      key={opsInd}
                      value={JSON.stringify({
                        subjectExamId: ops.syllabusCombinationSubjectExamId,
                        examId: ops.examId,
                      })}
                    >
                      {ops.exam.examName}
                    </option>
                  ))}
            </select>
          </div>
          <div key="examScheduleData" className="trtui-col-md-3 trtui-has-validation">
            <label>Exam Schedule</label>
            <select
              className="trtui-form-control"
              name="examScheduleId"
              onChange={(e) => {
                onSelectClassSectionSubjectExamSchedule(JSON.stringify(e.target.value))
              }}
              disabled={
                examScheduleData !== null && examScheduleData.formData.length > 0 ? false : true
              }
            >
              <option>
                {examScheduleData !== null && examScheduleData.formData.length > 0
                  ? 'Select Schedule'
                  : 'Loading...'}
              </option>
              {examScheduleData !== null &&
                examScheduleData.formData.length > 0 &&
                examScheduleData.formData.map((ops, opsInd) => (
                  <option
                    key={opsInd}
                    value={JSON.stringify({
                      id: ops.syllabusCombinationSubjectExamScheduleId,
                      date: ops.examDate,
                    })}
                  >
                    {ops.syllabusCombinationSubjectExam.exam.examName +
                      ' - ' +
                      dayjs(ops.examDate).format('DD-MM-YYYY')}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="trtui-row trtui-mt-2" key={classSectionMarksData}>
          {classSectionMarksData !== null &&
            classSectionMarksData.data.formData.length > 0 &&
            classSectionMarksData.data.formData.map((mData, mDataInd) => (
              <React.Fragment key={mDataInd}>
                <div className="trtui-col-md-4">
                  <h5 className="trtui-card-title">
                    {mData.applicationAYClassSectionRollNumber} - {mData.application.studentName}
                  </h5>
                </div>
                <div className="trtui-col-md-8">
                  <form
                    key={mData}
                    className="trtui-row"
                    onSubmit={(e) => {
                      mData.applicationAYClassSectionsSubjectExamMarksId
                        ? handleUpdateSubmit(e, mData)
                        : handleSubmit(e, mData)
                    }}
                  >
                    <div style={{ display: 'none' }} className="trtui-col-md-3">
                      <input
                        type="text"
                        name="applicationAYClassSectionId"
                        value={mData.applicationAYClassSectionId}
                        placeholder="Marks"
                        className="trtui-form-control"
                      />
                    </div>
                    {mData.applicationAYClassSectionsSubjectExamMarksId && (
                      <div style={{ display: 'none' }} className="trtui-col-md-3">
                        <input
                          type="text"
                          name="applicationAYClassSectionsSubjectExamMarksId"
                          value={mData.applicationAYClassSectionsSubjectExamMarksId}
                          placeholder="Marks"
                          className="trtui-form-control"
                        />
                      </div>
                    )}
                    <div className="trtui-col-md-3">
                      <input
                        type="text"
                        name="marks"
                        placeholder="Marks"
                        className="trtui-form-control"
                        defaultValue={mData.marks}
                      />
                    </div>
                    <div className="trtui-col-md-3">
                      <input
                        type="text"
                        name="grade"
                        placeholder="Grade"
                        className="trtui-form-control"
                        defaultValue={mData.grade}
                      />
                    </div>
                    <div className="trtui-col-md-4">
                      <input
                        type="text"
                        name="notes"
                        placeholder="Notes"
                        className="trtui-form-control"
                        defaultValue={mData.notes}
                      />
                    </div>
                    <div
                      className="trtui-col-md-2 trtui-text-right"
                      style={{
                        '-webkit-text-align': 'right',
                        'text-align': 'right',
                        paddingTop: '0.3rem',
                      }}
                    >
                      <button
                        type="submit"
                        title="Present"
                        className="trtui-btn trtui-btn-sm trtui-btn-success"
                      >
                        {mData.applicationAYClassSectionsSubjectExamMarksId ? (
                          <i className="fa fa-check" />
                        ) : (
                          <i className="fa fa-plus" />
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </React.Fragment>
            ))}
        </div>
      </div>
    </React.Fragment>
  )
}

MarksEntry.propTypes = {
  isLocalEnvironment: PropTypes.string,
  routeData: PropTypes.object,
}
